import { render, staticRenderFns } from "./DialogEditCatalogueIdea.vue?vue&type=template&id=cf5bfc8c"
import script from "./DialogEditCatalogueIdea.vue?vue&type=script&lang=js"
export * from "./DialogEditCatalogueIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports